import { motion } from "framer-motion";
import { Wheat, WheatOff, Flame, Drumstick } from "lucide-react";

const BENEFITS = [
  { icon: Wheat, label: "High in Fibre", tint: "#FFF4CC", ink: "#8A6D00" },
  { icon: Drumstick, label: "A Source of Protein", tint: "#FFE5CC", ink: "#B04A00" },
  { icon: Flame, label: "Low Calorie", tint: "#FFD1E8", ink: "#C40061" },
  { icon: WheatOff, label: "Gluten-Free", tint: "#DDFBFF", ink: "#007A99" },
];

export const Benefits = () => (
  <section className="pb-6" data-testid="benefits-section">
    <div className="max-w-[1440px] mx-auto px-4 sm:px-8 lg:px-12">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6 }}
        className="bg-white rounded-[32px] px-6 py-8 sm:px-10 shadow-sm flex flex-wrap items-center justify-center gap-x-10 gap-y-6"
      >
        <p className="text-[11px] font-bold tracking-[0.2em] uppercase text-[#2B0B3C]/50 w-full text-center sm:w-auto">
          Every Proppadom is
        </p>
        {BENEFITS.map((b, i) => (
          <motion.div
            key={b.label}
            initial={{ opacity: 0, y: 12 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: 0.1 + i * 0.1 }}
            className="flex items-center gap-3"
            data-testid={`benefit-${b.label.toLowerCase().replace(/[^a-z]+/g, "-")}`}
          >
            <span
              className="w-11 h-11 rounded-full flex items-center justify-center"
              style={{ backgroundColor: b.tint, color: b.ink }}
            >
              <b.icon size={20} strokeWidth={2.5} />
            </span>
            <span className="font-display text-lg font-bold text-[#2B0B3C]">{b.label}</span>
          </motion.div>
        ))}
      </motion.div>
    </div>
  </section>
);
